module.exports = __webpack_public_path__ + "img/event-3.605735e3.png";